import React, { FunctionComponent, useEffect } from "react";

import { ACard } from "@atiautomacao/ati-ui-library";
import { Skeleton, ProgressCard } from "@atiautomacao/ati-ui-library";
import { Box, Grid, useTheme } from "@mui/material";
import { getEntity } from "./TotalizerPowerStationAlarmReducer";
import { RootState } from "../../../../Config/Store";
import { useAppDispatch, useAppSelector } from "../../../../Config/Hooks";
import { Container } from "../../../../Shared/Components/AlarmTotalizers/AlarmTotalizers.theme";
import useInterval from "../../../../Shared/Hooks/useInterval";
import { TotalizerType } from "../../Overview/DashboardOverviewAlarmsPage";

const TOTALIZER_ALARM_FILTER_KEY = 'totalizer_alarm_filter';

const TotalizerAlarm: FunctionComponent<{ powerStationId: any, onClickTotalizer: any, 
    clearFilters: boolean }> = ({ powerStationId, onClickTotalizer, clearFilters }) => {

    const theme = useTheme();

    const bootstrapButton = {
        width: '100%', 
        border: 'none',
        borderStyle: "none",
        backgroundColor:  'transparent',
        backgroundImage: 'none',
        cursor: 'pointer',
        paddingBottom: '12px',
    };

    const styledTotalizeCard = {
        boxShadow: '0px 2px 4px 0px #00000029',
        borderRadius: '8px',
        '&:hover': {
            boxShadow: '#0062cc',
            transform: 'scale(1.05)',
            transition: "all 0.2s linear",
        }
    };

    const isLoadingAlarm = useAppSelector((state: RootState) => state.alarmPowerPlant.loading);
    const totalizers = useAppSelector((state: RootState) => state.totalizerPowerPlantAlarms.totalizers);
    const isLoading = useAppSelector((state: RootState) => state.totalizerPowerPlantAlarms.isLoading);
    const dispatch = useAppDispatch();

    const [opacityAlarmsSound, setOpacityAlarmsSound] = React.useState(false);
    const [opacityPowerNoCommunication, setOpacityPowerNoCommunication] = React.useState(false);
    const [opacityEquipmentNoCommunication, setOpacityEquipmentNoCommunication] = React.useState(false);
    const [opacityEquipmentAlarm, setOpacityEquipmentAlarm] = React.useState(false);
    const [opacityAlarmCritical, setOpacityAlarmCritical] = React.useState(false);
    const [opacityNotAcknowledged, setOpacityNotAcknowledged] = React.useState(false);
    const [opacityActive, setOpacityActive] = React.useState(false);
    const [valueTotalizerType, setValueTotalizerType] = React.useState<TotalizerType | null>(localStorage.getItem(TOTALIZER_ALARM_FILTER_KEY) as TotalizerType ?? "none");
    const userConfig = useAppSelector((state: RootState) => state.userConfigurarion);

    const handleLocalStorage = () => {
        const totalizer = localStorage.getItem(TOTALIZER_ALARM_FILTER_KEY) as TotalizerType;
        if (totalizer) {
            setValueTotalizerType(totalizer.toLowerCase() as TotalizerType);
            handleOpacity(totalizer.toLowerCase() as TotalizerType);
        }
    }
    useEffect(() => {
        dispatch(getEntity({ powerStationId: powerStationId }));
        handleLocalStorage();
    }, []);

    useEffect(() => {
            if(clearFilters){
                setValueTotalizerType("none");
                handleOpacity("none"); // Reseta a opacidade para todos os totalizadores
            }
    }, [clearFilters]);

    useInterval(() => {
        dispatch(getEntity({ powerStationId: powerStationId }));
    }, userConfig.alarmUpdateInterval); //5 minutes

    const handleOpacity = (type: TotalizerType) => {
        if(type === "alarms_sound"){
            setOpacityAlarmsSound(!opacityAlarmsSound);
        } else if (type === "power_station_no_communication") {
            setOpacityPowerNoCommunication(!opacityPowerNoCommunication);
        } else if (type === "equipment_no_communication") {
            setOpacityEquipmentNoCommunication(!opacityEquipmentNoCommunication);
        } else if (type === "equipments_alarmed") {
            setOpacityEquipmentAlarm(!opacityEquipmentAlarm);
        } else if (type === "active") {
            setOpacityActive(!opacityActive);
        } else if (type === "active_critical") {
            setOpacityAlarmCritical(!opacityAlarmCritical);
        } else if (type === "not_acknowledged") {
            setOpacityNotAcknowledged(!opacityNotAcknowledged);
        } else if (type === "none") {
            setOpacityPowerNoCommunication(false);
            setOpacityEquipmentNoCommunication(false);
            setOpacityEquipmentAlarm(false);
            setOpacityActive(false);
            setOpacityAlarmCritical(false);
            setOpacityNotAcknowledged(false);
        }
    }

    const handleOnclickByType = (totalizeType: TotalizerType) => {
        localStorage.setItem(TOTALIZER_ALARM_FILTER_KEY, totalizeType);
        setValueTotalizerType(totalizeType);
    }

    useEffect(() => {
        if (valueTotalizerType && !isLoadingAlarm) {
            onClickTotalizer(valueTotalizerType);
        }

    }, [valueTotalizerType, isLoadingAlarm]);

    if (isLoading) {
        return (
            <Box style={{ marginLeft: -16, marginRight: -16}}>
                <ACard
                    title={"Totalizadores e filtros"}
                    styleProps={{
                        cardStyle: {
                            backgroundColor: 'transparent',
                            backgroundImage: 'none',
                            boxShadow: 'none',
                            border: 'none',
                            borderRadius: 0,
                            padding: 0,
                            paddingBottom: 2,
                        },
                        contentStyle: { padding: 0,
                            marginLeft: '-24px'
                        },
                        headerStyle: {paddingBottom: 0, paddingTop: 0},
                        titleStyle: {fontSize: 16, fontWeight: 'semiBold', paddingBottom: 2},
                    }}
                >
                    <Container data-testid="loading-skeleton">
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                        <Skeleton animation="wave" height={100} variant="rectangular" width={200} />
                    </Container>
                </ACard>
            </Box>
        );
    }

    return (
        <Box style={{ marginLeft: -16, marginRight: -16}}>
            <ACard
                title={"Totalizadores e filtros"}
                styleProps={{
                    cardStyle: {backgroundColor: 'transparent', backgroundImage: 'none', boxShadow: 'none', border: 'none', borderRadius: 0, padding: 0},
                    contentStyle: { padding: 0},
                    headerStyle: {paddingBottom: 0, paddingTop: 0},
                    titleStyle: {fontSize: 16, fontWeight: 'semiBold', paddingBottom: 2},
                }}
            >
                    {totalizers && (
                    <Grid container sx={{ marginTop: -4 }}>
                        <Grid item
                            xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== 'alarms_sound' && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityAlarmsSound ? handleOnclickByType("none") : handleOnclickByType("alarms_sound")
                                    setOpacityAlarmsSound(!opacityAlarmsSound)
                                }}
                                disabled={valueTotalizerType !== "alarms_sound" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.alarmsSound}
                                    label="Sonoros ativos"
                                    background={valueTotalizerType === "alarms_sound" && opacityAlarmsSound ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] :
                                        theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "alarms_sound" && opacityAlarmsSound ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "alarms_sound" && opacityAlarmsSound && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "alarms_sound" && opacityAlarmsSound && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}
                                />

                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "power_station_no_communication" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityPowerNoCommunication ? handleOnclickByType("none") : handleOnclickByType("power_station_no_communication")
                                    setOpacityPowerNoCommunication(!opacityPowerNoCommunication)
                                }}
                                disabled={valueTotalizerType !== "power_station_no_communication" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.powerStationNoCommunication}
                                    label="Usinas s/ com."
                                    background={valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "power_station_no_communication" && opacityPowerNoCommunication && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "equipment_no_communication" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityEquipmentNoCommunication ? handleOnclickByType("none") : handleOnclickByType("equipment_no_communication")
                                    setOpacityEquipmentNoCommunication(!opacityEquipmentNoCommunication)

                                }}
                                disabled={valueTotalizerType !== "equipment_no_communication" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.equipmentsNoCommunication}
                                    label="Equipamentos s/ com."
                                    background={valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#FFF' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "equipment_no_communication" && opacityEquipmentNoCommunication && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "equipments_alarmed" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityEquipmentAlarm ? handleOnclickByType("none") : handleOnclickByType("equipments_alarmed")
                                    setOpacityEquipmentAlarm(!opacityEquipmentAlarm)
                                }}
                                disabled={valueTotalizerType !== "equipments_alarmed" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.equipmentsAlarmed}
                                    label="Equipamentos alarmados"
                                    background={valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "equipments_alarmed" && opacityEquipmentAlarm && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "active" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityActive ? handleOnclickByType("none") : handleOnclickByType("active")
                                    setOpacityActive(!opacityActive)
                                }}
                                disabled={valueTotalizerType !== "active" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.active}
                                    label="Alarmes ativos"
                                    background={valueTotalizerType === "active" && opacityActive ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "active" && opacityActive ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "active" && opacityActive && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "active" && opacityActive && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "active_critical" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityAlarmCritical ? handleOnclickByType("none") : handleOnclickByType("active_critical")
                                    setOpacityAlarmCritical(!opacityAlarmCritical)
                                }}
                                disabled={valueTotalizerType !== "active_critical" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.activeCritical}
                                    label="Críticos ativos"
                                    background={valueTotalizerType === "active_critical" && opacityAlarmCritical ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "active_critical" && opacityAlarmCritical ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "active_critical" && opacityAlarmCritical && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "active_critical" && opacityAlarmCritical && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4} lg={3} xl={12 / 7} paddingRight={'16px'}>
                            <button style={{ ...bootstrapButton, cursor: valueTotalizerType !== "not_acknowledged" && valueTotalizerType !== "none" ? 'not-allowed' : 'pointer' }}
                                onClick={() => {
                                    opacityNotAcknowledged ? handleOnclickByType("none") : handleOnclickByType("not_acknowledged")
                                    setOpacityNotAcknowledged(!opacityNotAcknowledged)
                                }}
                                disabled={valueTotalizerType !== "not_acknowledged" && valueTotalizerType !== "none"}
                            >
                                <ProgressCard
                                    value={totalizers.notAcknowledged}
                                    label="Não reconhecidos"
                                    background={valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged ? theme.palette.mode === 'light' ? theme.palette.primary.main : theme.palette.grey["A700"] : theme.palette.mode === 'light' ? '#fff' : '#1E1E1E'}
                                    textColor={valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged ? '#FFF' : theme.palette.text.primary}
                                    width={'100%'}
                                    valueFontSize={24}
                                    showProgressBar={false}
                                    styledPaperProps={{
                                        ...styledTotalizeCard,
                                        transform: valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged && theme.palette.mode === 'dark' ? 'scale(1.05)' : 'scale(1)',
                                        transition: "all 0.2s linear",
                                        opacity: valueTotalizerType === "not_acknowledged" && opacityNotAcknowledged && theme.palette.mode === 'dark' ? 1 : theme.palette.mode === 'dark' ? 0.5 : 1
                                    }}

                                />
                            </button>
                        </Grid>
                    </Grid>
                )}
            </ACard>
        </Box>
    );

}

export default TotalizerAlarm;